import { AppColor } from '../../shared/color/color';
import { CoreItem, CoreItemBackend } from '../core-item/core-item';
import { ContactHubSpot } from '../hubspot/hubspot';

export interface ResumeBackend extends CoreItemBackend {
  type?: ResumeType;
  subData: ResumeSubData;
}

export enum ResumeType {
  real = 'real',
  ai = 'ai',
}

export interface Resume extends CoreItem {
  subData: ResumeSubData;
}

export enum ResumeSource {
  chromeExtension = 'chromeExtension',
  linkedIn = 'linkedIn',
  pdf = 'pdf',
  manual = 'manual',
  ai = 'ai',
  hubspot = 'HubSpot',
}

export function getResumeSourceName(resume?: Resume) {
  if (resume?.subData?.source === ResumeSource.ai) {
    return 'AI';
  } else if (resume?.subData?.source === ResumeSource.pdf) {
    return 'PDF';
  } else if (resume?.subData?.source === ResumeSource.chromeExtension) {
    return 'Extension';
  } else if (resume?.subData?.source === ResumeSource.linkedIn) {
    return 'LinkedIn';
  } else if (resume?.subData?.source === ResumeSource.manual) {
    return 'Manual';
  } else {
    return '';
  }
}

export function getResumeSourceColor(resume?: Resume) {
  if (resume?.subData?.source === ResumeSource.ai) {
    return AppColor.volcano;
  } else if (resume?.subData?.source === ResumeSource.pdf) {
    return AppColor.red;
  } else if (resume?.subData?.source === ResumeSource.chromeExtension) {
    return AppColor.geekblue;
  } else if (resume?.subData?.source === ResumeSource.linkedIn) {
    return AppColor.blue;
  } else if (resume?.subData?.source === ResumeSource.manual) {
    return AppColor.purple;
  } else {
    return 'darkgrey';
  }
}

export interface ResumeSubData {
  resumeContent?: string; // instant resume content.
  fileName?: string;
  url?: string;
  source: ResumeSource;

  summary?: string;

  hubspotContact?: ContactHubSpot;

  linkedInProviderId?: string;

  content?: {
    portraitImageUrl?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    gender?: string;
    painPoints?: string[];
    personalInformation?: string;
    mostRecentCompany?: string;
    mostRecentPosition?: string;
    workExperience?: string;
    education?: string;
    skills?: string[];
    certifications?: string[];
    awards?: string[];
    publications?: string[];
    languages?: string[];
    interests?: string[];
    references?: string[];
    otherDetails?: string;

    voice?: string;
    personalityIdList?: string[];
  };
}
